/**
 * "Move to" in the task modal (redesign 05.10.2026): the task goes to the END
 * of the other list — as a drop below its last card does — and both lists are
 * renumbered so positions stay dense (0, 1, 2 …). Every other task is
 * returned as it was. Pure: the board tab applies it inside updateBoard.
 *
 * @returns {Array} the board's next tasks, or the same array when nothing moves
 */
export function moveTaskToList(tasks, taskId, groupId, now = new Date().toISOString()) {
  const task = (tasks || []).find((t) => t.id === taskId);
  if (!task || groupId == null || task.groupId === groupId) return tasks;
  const moved = { ...task, groupId, updatedAt: now };
  const rest = tasks.filter((t) => t.id !== taskId);
  const inList = (gid) => rest.filter((t) => t.groupId === gid).sort((x, y) => (x.position ?? 0) - (y.position ?? 0));
  const renumber = (list) => list.map((t, i) => (t.position === i ? t : { ...t, position: i }));
  const touched = new Map([...renumber(inList(task.groupId)), ...renumber([...inList(groupId), moved])].map((t) => [t.id, t]));
  return [...rest.filter((t) => !touched.has(t.id)), ...touched.values()];
}
